import { MarkdownRenderer } from '@/components';
import { getNestedString, useConfig } from '@/utils/useConfig';
import FuseLoading from '@fuse/core/FuseLoading';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';

function ConditionsPage() {

    const { config, loading, error } = useConfig('terms_config');

    if (loading) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <FuseLoading />
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="bg-white p-8 rounded-lg shadow-md">
                    <div className="flex items-center gap-3 text-red-600 mb-4">
                        <FuseSvgIcon size={24}>heroicons-outline:exclamation-triangle</FuseSvgIcon>
                        <span className="font-semibold">Error Loading Terms of Service</span>
                    </div>
                    <p className="text-gray-600">{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header Section */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="mx-auto px-5 py-10">
                    <div className="relative flex items-center justify-center">
                        <div className="absolute left-10 flex items-center">
                            <a
                                href="/"
                                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
                            >
                                <FuseSvgIcon size={20}>heroicons-outline:arrow-left</FuseSvgIcon>
                            </a>
                        </div>

                        <div className="flex items-center gap-3">
                            <h1 className="text-4xl font-bold text-gray-900">Terms and Conditions</h1>
                        </div>
                    </div>
                </div>
            </div>

            {/* Content Section */}
            <div className="max-w-4xl mx-auto px-5 py-10">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                    <div className="p-10 md:p-20">
                        <div className="prose prose-lg prose-gray max-w-none 
                                       prose-headings:text-gray-900 prose-headings:font-semibold
                                       prose-h1:text-3xl prose-h1:mb-8 prose-h1:mt-0
                                       prose-h2:text-2xl prose-h2:mb-6 prose-h2:mt-8 prose-h2:border-b prose-h2:border-gray-200 prose-h2:pb-2
                                       prose-h3:text-xl prose-h3:mb-4 prose-h3:mt-6
                                       prose-p:text-gray-700 prose-p:leading-relaxed prose-p:mb-4
                                       prose-ul:mb-6 prose-li:mb-2 prose-li:text-gray-700
                                       prose-strong:text-gray-900 prose-strong:font-semibold
                                       prose-a:text-blue-600 prose-a:no-underline hover:prose-a:text-blue-800 hover:prose-a:underline
                                       prose-blockquote:border-l-4 prose-blockquote:border-blue-200 prose-blockquote:bg-blue-50 prose-blockquote:p-4 prose-blockquote:italic
                                       prose-code:bg-gray-100 prose-code:px-2 prose-code:py-1 prose-code:rounded prose-code:text-sm"
                        >
                            <MarkdownRenderer markdown={getNestedString(config, 'content')} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}

export default ConditionsPage;